export * from './interface';
export * from './partial';

import BasicLayout from './basicLayout';
import WidePageLayout from './wideLayout';
import StaticPageLayout from './staticPageLayout';
import SharePageLayout from './sharePageLayout';
import NormalPageLayout from './normalPageLayout';
import browserCheck from './partial/browserCheck';
export { BasicLayout, WidePageLayout, StaticPageLayout, SharePageLayout, NormalPageLayout, browserCheck};
